import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { useCssVariables } from "../hooks/useCssVariables.js";
const toolbarStoreIdContext = createContext(null);
const toolbarCssStylesContext = createContext(null);
const toolbarCssVariablesContext = createContext(null);
function ToolbarRootContext(props) {
  const { children, storeId, cssVarOverrides } = props;
  const cssVars = useCssVariables(cssVarOverrides);
  return /* @__PURE__ */ jsx(toolbarStoreIdContext.Provider, { value: storeId, children: /* @__PURE__ */ jsx(toolbarCssStylesContext.Provider, { value: cssVars.styles, children: /* @__PURE__ */ jsx(toolbarCssVariablesContext.Provider, { value: cssVars.variables, children }) }) });
}
export {
  ToolbarRootContext,
  toolbarCssStylesContext,
  toolbarCssVariablesContext,
  toolbarStoreIdContext
};
//# sourceMappingURL=ToolbarRootContext.js.map
